import Form, { FormProps } from "@/shared/form/form";
import { FieldsType } from "../model/types";
import Input from "@/shared/form/input";
import { LocalizedValue } from "@/shared/form/localized-value";
import { useTranslations } from "use-intl";
import Checkbox from "@/shared/form/checkbox";
import { UploadWithCrop } from "@/shared/form/upload";
import { onlyOneDocument } from "@/shared/form/upload/ui/attachment";

export function DynamicProcessModelForm(props: FormProps<FieldsType>) {
  const t = useTranslations("DynamicProcesses");

  return (
    <Form layout="vertical" {...props}>
      <Form.Item<FieldsType> name="id" hidden>
        <Input />
      </Form.Item>

      <LocalizedValue
        name="name"
        label={t("Name")}
        render={({ placeholder }) => <Input placeholder={placeholder} />}
        myLocaleRules={[{ required: true }]}
      />

      <Form.Item<FieldsType>
        name="allowAttachments"
        valuePropName="checked"
        initialValue={false}
        label={t("Allow attachments")}
      >
        <Checkbox />
      </Form.Item>

      <Form.Item<FieldsType>
        name="active"
        valuePropName="checked"
        initialValue={true}
        label={t("Active")}
      >
        <Checkbox />
      </Form.Item>

      <Form.Item<FieldsType>
        name="icon"
        label={t("Icon")}
        {...onlyOneDocument()}
      >
        <UploadWithCrop maxCount={1} showUploadList />
      </Form.Item>
    </Form>
  );
}
